import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Button, ButtonSize } from '@cian/button-component';
import { Checkbox } from '@cian/checkbox-component';
import { PasswordField } from '@cian/password-field-component';
import { TextField, VisualSize } from '@cian/text-field-component';
import * as React from 'react';
import { isValidPhone } from '../../../../utils/validation';
import { ERegisterStatus, ERegisterErrorType } from '../../../../types/registration';
import { Tooltip, ETooltipSize } from '../../../Tooltip';
import * as styles from './styles.css';
export var RegistrationForm = /*#__PURE__*/function (_React$Component) {
  _inherits(RegistrationForm, _React$Component);

  var _super = _createSuper(RegistrationForm);

  function RegistrationForm(props) {
    var _this;

    _classCallCheck(this, RegistrationForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handlePasswordValueChange", function (password) {
      _this.setState({
        password: password,
        isChanged: true,
        isPasswordInvalid: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePhoneValueChange", function (phone) {
      _this.setState({
        phone: phone,
        isChanged: true,
        isPhoneInvalid: !!phone && !isValidPhone(phone)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleProfessionalValueChange", function (isProfessional) {
      _this.setState({
        isChanged: true,
        isProfessional: isProfessional
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubscriptionValueChange", function (wantsSubscription) {
      _this.setState({
        isChanged: true,
        wantsSubscription: wantsSubscription
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmitClick", function (event) {
      event.preventDefault();
      var status = _this.props.registration.register.status;

      if ([ERegisterStatus.Loading, ERegisterStatus.Succeed].includes(status)) {
        return;
      }

      var _this$state = _this.state,
          password = _this$state.password,
          phone = _this$state.phone,
          isProfessional = _this$state.isProfessional,
          wantsSubscription = _this$state.wantsSubscription;

      if (!password || phone && !isValidPhone(phone)) {
        _this.setState({
          isPasswordInvalid: !password,
          isPhoneInvalid: !!phone && !isValidPhone(phone)
        });

        return;
      }

      _this.setState({
        isChanged: false
      });

      var login = _this.props.login;

      _this.props.register({
        email: login,
        password: password,
        phone: phone,
        isProfessional: isProfessional,
        wantsSubscription: wantsSubscription
      });
    });

    _this.state = {
      password: '',
      phone: '',
      isProfessional: false,
      wantsSubscription: true,
      isChanged: !!props.registration.register.error,
      isPasswordInvalid: false,
      isPhoneInvalid: false
    };
    return _this;
  }

  _createClass(RegistrationForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          withSubscriptionAgreement = _this$props.withSubscriptionAgreement,
          _this$props$registrat = _this$props.registration.register,
          status = _this$props$registrat.status,
          errorType = _this$props$registrat.errorType,
          error = _this$props$registrat.error;
      var _this$state2 = this.state,
          password = _this$state2.password,
          phone = _this$state2.phone,
          isProfessional = _this$state2.isProfessional,
          wantsSubscription = _this$state2.wantsSubscription,
          isChanged = _this$state2.isChanged,
          isPasswordInvalid = _this$state2.isPasswordInvalid,
          isPhoneInvalid = _this$state2.isPhoneInvalid;
      var isDisabled = status === ERegisterStatus.Loading || status === ERegisterStatus.Succeed;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: styles['password_row']
      }, /*#__PURE__*/React.createElement(Tooltip, {
        size: ETooltipSize.M,
        content: status === ERegisterStatus.Failed && errorType && errorType === ERegisterErrorType.Password && !isChanged ? error : undefined
      }, /*#__PURE__*/React.createElement(PasswordField, {
        placeholder: "\u041F\u0440\u0438\u0434\u0443\u043C\u0430\u0439\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C",
        name: "password",
        maxLength: 30,
        inputStyle: styles['password_input'],
        invalid: status === ERegisterStatus.Failed && errorType && errorType === ERegisterErrorType.Password && !isChanged || isPasswordInvalid,
        required: true,
        value: password,
        onValueChange: this.handlePasswordValueChange,
        size: VisualSize.MEDIUM,
        disabled: isDisabled
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles['phone_row']
      }, /*#__PURE__*/React.createElement(Tooltip, {
        size: ETooltipSize.M,
        content: status === ERegisterStatus.Failed && errorType && errorType === ERegisterErrorType.Phone && !isChanged ? error : undefined
      }, /*#__PURE__*/React.createElement(TextField, {
        placeholder: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        name: "phone",
        inputStyle: styles['phone_input'],
        invalid: status === ERegisterStatus.Failed && errorType && errorType === ERegisterErrorType.Phone && !isChanged || isPhoneInvalid,
        value: phone,
        mask: "+7 (999) 999-99-99",
        onValueChange: this.handlePhoneValueChange,
        size: VisualSize.MEDIUM,
        disabled: isDisabled
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles['professional_row']
      }, /*#__PURE__*/React.createElement(Checkbox, {
        containerStyle: styles['professional_checkbox'],
        value: isProfessional,
        onValueChange: this.handleProfessionalValueChange,
        label: "\u042F \u2014 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B",
        disabled: isDisabled
      }), /*#__PURE__*/React.createElement("span", {
        className: styles['professional_info']
      }, /*#__PURE__*/React.createElement("svg", {
        viewBox: "0 0 17 17",
        width: "17",
        height: "17"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M8.4 0C3.7.1-.1 3.9 0 8.6.1 13.3 3.9 17 8.6 17c4.7-.1 8.4-3.9 8.4-8.6-.1-4.7-3.9-8.5-8.6-8.4zm0 13.7c-.8 0-1.3-.6-1.3-1.3 0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.3c.1.7-.4 1.2-1.1 1.2zm3-6.1c-.2.2-.5.5-1 .9l-.5.4c-.3.2-.5.4-.6.6-.1.2-.1.2-.1.5v.1h-2v-.2c0-.7 0-1.1.3-1.4.6-.5 1.6-1.1 1.6-1.1.1-.1.3-.3.3-.4.2-.3.3-.5.3-.7 0-.3-.1-.6-.3-.8-.1-.3-.4-.4-.9-.4s-.8.2-1 .5c-.2.3-.3.6-.3 1v.1h-2v-.1c.1-1.3.5-2.2 1.3-2.7.5-.4 1.2-.6 1.9-.6 1 0 1.8.2 2.5.7.7.5 1 1.2 1 2.1 0 .6-.2 1.1-.5 1.5z"
      })), /*#__PURE__*/React.createElement("div", {
        className: styles['professional_info_tooltip']
      }, /*#__PURE__*/React.createElement("p", null, "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0442\u043C\u0435\u0442\u044C\u0442\u0435, \u0435\u0441\u043B\u0438 \u0432\u044B", /*#__PURE__*/React.createElement("br", null), "\u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0438\u044D\u043B\u0442\u043E\u0440,", /*#__PURE__*/React.createElement("br", null), "\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043B\u044C \u0430\u0433\u0435\u043D\u0442\u0441\u0442\u0432\u0430 \u0438\u043B\u0438 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A.")))), withSubscriptionAgreement && /*#__PURE__*/React.createElement("div", {
        className: styles['subscription_row']
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: wantsSubscription,
        onValueChange: this.handleSubscriptionValueChange,
        label: "\u0425\u043E\u0447\u0443 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u043D\u043E\u0432\u043E\u0441\u0442\u0438 Cian.ru",
        disabled: isDisabled
      })), /*#__PURE__*/React.createElement("div", {
        className: styles['submit_row']
      }, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        block: true,
        size: ButtonSize.M,
        isSync: isDisabled,
        onClick: this.handleSubmitClick
      }, "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F")));
    }
  }]);

  return RegistrationForm;
}(React.Component);